import { render, staticRenderFns } from "./Main2.vue?vue&type=template&id=4fbf9375&scoped=true&"
import script from "./Main2.vue?vue&type=script&lang=js&"
export * from "./Main2.vue?vue&type=script&lang=js&"
import style0 from "./Main2.vue?vue&type=style&index=0&id=4fbf9375&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbf9375",
  null
  
)

export default component.exports